export const attachDialogStyles = {
  width: '52%',
  maxWidth: 'none',
}
